
import React  , { useRef ,  useState , useEffect  , useCallback , forwardRef , useContext, useLayoutEffect  } from 'react'; 

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import classnames from 'classnames';
import { produce } from 'immer';
import 'scss/components/ui/PopoverMenu.scss';

const PopoverMenu = React.forwardRef((props, ref) => {

    let editedProps = produce( props , draft => {
        delete draft.onClose ;
        draft.className = classnames('DMFUI_Chip_PopoverMenuBase' , props.className );
    });

    useLayoutEffect( ()=>{
        if( props.anchorEl ){
            if( props.placement == 'bottom-end'){

            }
        }
    });

    const open = ( props.open ?? true );

    return  ( 
        <ClickAwayListener mouseEvent="onMouseDown" touchEvent="onTouchStart" onClickAway={props.onClose}>
        <Popper {...editedProps} open={open} disablePortal onClick={(event) => event.stopPropagation()}>
                    <div className="DMFUI_Chip_PopoverMenuBase_triangle"></div>
                <Paper sx={{
                    boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.05)',
                    border: 'solid 0.5px #E6E6E6',
                    borderRadius: '6px',
                    '&.MuiPaper-elevation1': {
                        boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.05) !important'
                    }
                }}> 
                    { props.children }
                </Paper>
            </Popper>
        </ClickAwayListener> 
    );
});

export default PopoverMenu;